import { APIConstants } from '../../constants';
import axios from 'axios';

export const heartbeat = async (
  config: (key: string) => string | undefined
): Promise<void> => {
  try {
    const heartbeatSsoSessionUrl = `${config(APIConstants.CONFIG.HEARTBEAT_URL)}`;
    const options = {
      method: 'POST',
      url: heartbeatSsoSessionUrl,
    };
    await axios(options);
  } catch (error) {
    throw error;
  }
};
